import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowDownLeftIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M5.83203 14.1667L14.9987 5'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M5.10961 9.1665C5.10961 9.1665 4.71386 13.8611 5.4263 14.5736C6.13872 15.286 10.8334 14.8902 10.8334 14.8902'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowDownLeftIcon;
